import { Modal, Result } from '@bfe/moly';
import { ModalProps } from '@bfe/moly/dist/es/components/ui/modal';
import { IResult } from '@bfe/moly/dist/es/components/ui/result';

interface IProps {
  modalProps: Omit<ModalProps, 'title'>;
  resultProps: IResult;
}

const ResultModal = ({ modalProps, resultProps }: IProps) => {
  return (
    <Modal title={false} {...modalProps}>
      <Result {...resultProps}></Result>
    </Modal>
  );
};

export default ResultModal;
